import React from 'react';
import { NavLink } from 'react-router-dom';

import './WidgetsGrid.less';
import WidgetCard from '../UI/WidgetCard';

export default function WidgetsGrid({ items, onClick, cardTextStyle }) {
  return (
    <ul className="widgets-grid">
      { items.map((item, i) => (
        <li key={`widget-${i}`}>
          { onClick ? (
            <WidgetCard textStyle={cardTextStyle} name={item.name} inactive={item.inactive} onClick={() => onClick(item)} />
          ) : (
            <NavLink to={item.url}>
              <WidgetCard textStyle={cardTextStyle} name={item.name} inactive={item.inactive} />
            </NavLink>
          )}
        </li>
      ))}
    </ul>
  );
}
